<div class="whatsapp__container">
  <div class="whatsapp__form">
    <app-select
      placeholder="{{ 'appSelect.whatsAppTemplate.placeholder' | translate }}"
      [disableSearch]="true"
      [(ngModel)]="document.whatsapp_template"
      [options]="[
        { key: WhatsappTemplateEnum.Standard, value: 'appSelect.whatsAppTemplate.standard' | translate, height: 46, fontSize: 16 },
        { key: WhatsappTemplateEnum.Formal, value: 'appSelect.whatsAppTemplate.formal' | translate, height: 46, fontSize: 16 },
        { key: WhatsappTemplateEnum.Casual, value: 'appSelect.whatsAppTemplate.casual' | translate, height: 46, fontSize: 16 },
        { key: WhatsappTemplateEnum.Direct, value: 'appSelect.whatsAppTemplate.direct' | translate, height: 46, fontSize: 16 }
      ]"
    >
    </app-select>
  </div>

  <app-signature-whatsapp-preview [user]="currentUser" [document]="document" [selectedLang]="document.locale.language" [whatsappType]="document.whatsapp_template"></app-signature-whatsapp-preview>
</div>
